import app from 'flarum/forum/app';

/**
 * Leaves it to the browser to follow a post's links back to this site that
 * aren't pages of the app - a photo under /assets/files/, an old phpBB
 * viewtopic.php address (redirected server-side) - instead of core's
 * routeInternalLinks(), new in Flarum 2.0.0.
 *
 * That listener takes over every click on a.UrlLink--internal, the class the
 * Formatter gives any link to the forum's own origin, and hands the path to
 * m.route.set() without checking it is a route at all: Mithril then falls
 * back to the default route, so clicking a post's link to a photo landed on
 * the home page instead (reported 2026-10-11 - ~620 posts link a migrated
 * phpBB attachment that way, ~550 an old phpBB address). Opening it in a
 * new tab worked, being left to the browser.
 *
 * Runs in the capture phase on document, so before core's own (bubbling)
 * listener there: a link whose path matches no route just loses the
 * UrlLink--internal class core's listener looks for, and the browser then
 * follows it as a plain link. Decided at click time rather than when posts
 * render, so it covers every place post HTML shows up, the same way core's
 * own listener does.
 */
export default function followNonRouteInternalLinks() {
  let routePatterns = null;
  document.addEventListener('click', e => {
    const link = e.target?.closest?.('a.UrlLink--internal');
    if (!link) return;
    let path;
    try {
      path = new URL(link.href, document.baseURI).pathname;
    } catch {
      return;
    }

    // app.routes' paths don't carry the base path (core's mapRoutes() adds
    // it when registering them with Mithril).
    const basePath = app.forum.attribute('basePath') || '';
    if (basePath && path.startsWith(basePath)) path = path.slice(basePath.length) || '/';
    routePatterns ??= Object.values(app.routes).map(route => routeRegExp(route.path));
    if (!routePatterns.some(pattern => pattern.test(path))) {
      link.classList.remove('UrlLink--internal');
    }
  }, true);
}

// Mithril's route syntax: ":name" stands for one path segment, ":name..." for
// the rest of the path, everything else is literal.
function routeRegExp(pattern) {
  const source = pattern.split(/(:[A-Za-z_$][\w$]*(?:\.\.\.)?)/).map(part => part.startsWith(':') ? part.endsWith('...') ? '.*' : '[^/]+' : part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('');
  return new RegExp(`^${source}/?$`);
}